import { ComingSoon } from "components/commons";
import { SendbirdChat } from "components/layouts/SendbirdChat";
import { inboxTabs } from "helpers/constants";
import { TradeCard } from "modules/activities/components/TradeCard";
import { useController } from "./Controller";
import { Subcribed } from "../components/Subcribed";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

function Inbox() {
  const { currentTab, handleChangeTab, state } = useController();

  const tabRender = () => {
    switch (currentTab) {
      case "Chat":
        return <SendbirdChat />;

      case "Activities":
        return <TradeCard state={state} />;

      case "Subscribed":
        return <Subcribed />;

      case "System":
        return <ComingSoon />;

      default:
        break;
    }
  };

  return (
    <div className="flex-1">
      <div className="text-xl pb-3">Inbox</div>
      <div className="w-full flex justify-evenly items-center gap-1 border-b border-gray-800 text-center z-10">
        {inboxTabs.map((tab) => (
          <div
            className={classNames(
              tab.name === currentTab
                ? "border-secondary text-white"
                : "border-transparent text-slate-300 hover:border-secondary hover:text-white",
              "whitespace-nowrap border-b-4 rounded text-sm font-normal py-2 w-full px-2 cursor-pointer"
            )}
            onClick={() => {
              handleChangeTab(tab.name);
            }}
          >
            {tab.name}
          </div>
        ))}
      </div>
      <div className="py-4">{tabRender()}</div>{" "}
    </div>
  );
}

export { Inbox as default };
